export default "__VITE_ASSET__CadaKIaa__"